document.addEventListener('DOMContentLoaded', () => {
	/* ==========================================================================
     1. Intersection Observer (inviewフェードイン & スケール監視の統合)
     ========================================================================== */
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('active');
					obs.unobserve(entry.target); // 一度発火したら監視を解除
				}
			});
		},
		{
			rootMargin: '0px 0px -10% 0px',
		},
	);

	document.querySelectorAll('.fadein, .imgScale').forEach((el) => {
		observer.observe(el);
	});

	/* ==========================================================================
     2. Swiper 管理
     ========================================================================== */
	let swiperTopInstance = null; // SPのみで動かすSwiper
	let swiperBottomInstance = null; // PC・SP両方で「常に動かす」Swiper

	// Swiper共通オプション（フェード）
	const swiperOptions = {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true, // 重なりを綺麗にする
		},
		speed: 1000,
		slidesPerView: 1,
		autoplay: {
			delay: 2500,
			pauseOnMouseEnter: true,
			disableOnInteraction: false,
		},
	};

	// --- ① 常時動かす swiper-bottom の初期化 ---
	if (document.querySelector('.prodBox .swiper-bottom')) {
		swiperBottomInstance = new Swiper('.prodBox .swiper-bottom', swiperOptions);
	}

	// --- ② 画面幅に応じて swiper-top を「初期化 / 解体」する処理 ---
	function initSwiperTop() {
		if (document.querySelector('.swiper-top') && !swiperTopInstance) {
			swiperTopInstance = new Swiper('.swiper-top', swiperOptions);
		}
	}

	function destroySwiperTop() {
		if (swiperTopInstance) {
			swiperTopInstance.destroy(true, true);
			swiperTopInstance = null;
		}
		// PC表示時にSwiperが残したインラインスタイルをクリーンアップ
		document.querySelectorAll('.swiper-top .swiper-wrapper, .swiper-top .swiper-slide').forEach((el) => {
			el.removeAttribute('style');
		});
	}

	// 画面幅（リサイズ）検知
	function handleResize() {
		const isSp = window.innerWidth <= 1024; // 1024px以下はSP

		if (isSp) {
			document.body.classList.remove('is-pc');
			initSwiperTop(); // SP時は top もスライダーにする
		} else {
			document.body.classList.add('is-pc');
			destroySwiperTop(); // PC時は top のみを解体して横並びにする
		}
	}

	// 初回実行とリサイズイベント登録
	handleResize();
	window.addEventListener('resize', handleResize);
});
